(function($) {

$(function () {
    const $sections = $('.js-scroll');
    const $bgs = $('.page-top_bg_img');
    const $black = $('.page-top_bg_black');

    if (!$sections.length || !$bgs.length || !$black.length) return;

    function clamp(v, min, max) {
        return Math.max(min, Math.min(max, v));
    }

    function getCenter($el) {
        return $el.offset().top + ($el.outerHeight() / 2);
    }

    function update() {
    const winTop = $(window).scrollTop();
    const winH = $(window).height();
    const anchor = winTop + winH * 0.8;

    $bgs.css('opacity', 0);
    $black.css('opacity', 0);

    // ▼ 1枚目より前
    if (anchor < getCenter($sections.eq(0))) {
        $bgs.eq(0).css('opacity', 1);
        return;
    }

    let i = 0;
    for (; i < $sections.length - 1; i++) {
        const c0 = getCenter($sections.eq(i));
        const c1 = getCenter($sections.eq(i + 1));
        if (anchor >= c0 && anchor < c1) break;
    }

    // ▼ 最後のセクション
    if (i === $sections.length - 1) {
        $bgs.eq(i).css('opacity', 1);
        return;
    }

    const curCenter = getCenter($sections.eq(i));
    const nextCenter = getCenter($sections.eq(i + 1));
    const progress = clamp((anchor - curCenter) / (nextCenter - curCenter), 0, 1);

    let curOpacity = 0;
    let nextOpacity = 0;
    let blackOpacity = 0;

    // ▼ 明るい時間を長くしたフェード
    if (progress < 0.2) {
        const t = progress / 0.2;
        curOpacity = 1;
        blackOpacity = 1 - t;

    } else if (progress < 0.8) {
        curOpacity = 1;

    } else {
        const t = (progress - 0.8) / 0.2;
        curOpacity = 1 - t;
        nextOpacity = t;
        blackOpacity = t;
    }

    $bgs.eq(i).css('opacity', curOpacity);
    $bgs.eq(i + 1).css('opacity', nextOpacity);
    $black.css('opacity', blackOpacity);
    }

    let ticking = false;
    function requestUpdate() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
        update();
        ticking = false;
        });
    }

    $(window).on('load scroll resize', requestUpdate);
    update();
});




/* ローディングアニメーション
---------------------------------------------------------------------------- */
$(document).ready(function() {
    $('html, body').removeClass('c-stop');

    if ($('.c-loading').length > 0) {
        
		if (localStorage.getItem("visited")) {
            $('html, body').removeClass('c-stop');
            $('.c-loading').css('display', 'none');
		} else {
            localStorage.setItem("visited", "true");
            setTimeout(function () {
                $('.c-loading_ttl').css('opacity', '1');
            }, 100);
            setTimeout(function () {
                $('.c-loading').fadeOut(1500);
            }, 2000);
            setTimeout(function () {
                $('html, body').removeClass('c-stop');
            }, 3500);

        }

	}
});




/* 慣性スクロール
---------------------------------------------------------------------------- */
const lenis = new Lenis();

function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
}

requestAnimationFrame(raf);


})(jQuery);



/* 外部リンク 別タブ
---------------------------------------------------------------------------- */
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
   links[i].target = '_blank';
   links[i].rel = 'noreferrer noopener';
  }
}